import { CSSProperties } from 'react';

export type ProgressBarType = {
  percentage: string | number;
  backgroundProps?: CSSProperties;
  foregroundProps?: CSSProperties;
  children?: React.ReactNode;
};

export const ProgressBar: React.FC<ProgressBarType> = (props) => {
  const { percentage, backgroundProps, foregroundProps, children } = props;

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#E9ECF3',
        overflow: 'hidden',
        ...backgroundProps,
      }}
    >
      <div
        style={{
          width: `${percentage}%`,
          backgroundColor: '#31ACBF',
          ...foregroundProps,
        }}
      >
        {children}
      </div>
    </div>
  );
};
